import { TemplateFont } from '../types';
import { createAction } from 'redux-act';

export const fetchTemplates = createAction();
export const fetchTemplatesSuccess = createAction<any[]>();
export const fetchTemplatesFonts = createAction();
export const fetchTemplatesFontsSuccess = createAction<TemplateFont[]>();
export const fetchTemplatesFailed = createAction();
